export default __webpack_public_path__ + "static/media/12.8b1358f2.webp";